import commonHelper from '@/app/utility/common.helper.utility';
import invoiceApprovalDetails from '../../invoiceApproval/invoiceApprovalDetails';
export default {
  name: 'pendingInvoicesSync',
  props: ['cardName'],
  watch: {
    currentPage1: function() {
      if (this.cardName === 'pendingInvSync') {
        this.getPendingInvSyncData();
      } else if (this.cardName === 'pendingGrnSync') {
        this.getPendingGrnSyncData();
      } else if (this.cardName === 'pendingRecDoc') {
        this.getPendingRecDocData();
      }
    },
    perPage1: function() {
      this.currentPage1 = 1;
      if (this.cardName === 'pendingInvSync') {
        this.getPendingInvSyncData();
      } else if (this.cardName === 'pendingGrnSync') {
        this.getPendingGrnSyncData();
      } else if (this.cardName === 'pendingRecDoc') {
        this.getPendingRecDocData();
      }
    }
  },
  components: { invoiceApprovalDetails },
  data() {
    return {
      loader: false,
      pendingSyncData: [],
      pendingSyncFields: [],
      unsubscribe: null,
      perPage1: commonHelper.perPageRecord,
      pageOptions1: commonHelper.getPageOption(),
      totalRows1: null,
      currentPage1: 1,
      downloadpayload: null,
      showInvAppDtlsModal: false,
      invoiceRowData: {},
      wfMenuId: null,
      eventId: null,
      userId: this.$store.state.auth.userId,
      sortFlag: {
        creationDate: true,
        lastActionDate: false,
        subDate: false,
        vendorName: false,
        userEmail: false
      },
      arrowDate: false,
      arrowSubDate: false,
      arrowVenName: false,
      arrowUserEmail: false,
      arrowLastActionDate: false, // 1.1 <Anuj>
      orderName: 'creation_date',
      orderBy: 'DESC'
      // arrowSubDate: false,
      // arrowRecDate: false,
    };
  },
  created() {
    if (this.cardName === 'pendingInvSync') {
      this.pendingSyncFields = [
        {
          key: 'vendor_name',
          label: 'Vendor Name',
          class: 'text-center'
        },
        {
          key: 'inv_num',
          label: 'Invoice Number',
          class: 'text-center inv-num-width'
        },
        {
          key: 'po_num',
          label: 'PO Number',
          class: 'text-center po-num-width'
        },
        {
          key: 'user_email',
          label: 'User Email',
          class: 'text-center email-width'
        },
        {
          key: 'receipt_number',
          label: 'Receipt Number',
          class: 'text-center po-num-width'
        },
        {
          key: 'approval_status',
          label: 'Approval Status',
          class: 'text-center po-num-width'
        },
        {
          key: 'submission_date',
          label: 'Submission Date',
          class: 'text-center'
        },
        {
          key: 'creation_date',
          label: 'Creation Date',
          class: 'text-center'
        },
        // 1.1 <Anuj>
        {
          key: 'last_action_date',
          label: 'Last Action Date',
          class: 'text-center'
        },
        {
          key: 'status_code',
          label: 'Status Code',
          class: 'text-center'
        },
        {
          key: 'status_message',
          label: 'Status Message',
          class: 'text-center'
        },
        {
          key: 'view_details',
          label: 'View Details',
          class: 'text-center'
        }
      ];
      this.getPendingInvSyncData();
    } else if (this.cardName === 'pendingGrnSync') {
      this.pendingSyncFields = [
        {
          key: 'vendor_name',
          label: 'Vendor Name',
          class: 'text-center'
        },
        {
          key: 'inv_num',
          label: 'Invoice Number',
          class: 'text-center inv-num-width'
        },
        {
          key: 'user_email',
          label: 'User Email',
          class: 'text-center email-width'
        },
        {
          key: 'receipt_number',
          label: 'Receipt Number',
          class: 'text-center po-num-width'
        },
        {
          key: 'approval_status',
          label: 'Approval Status',
          class: 'text-center po-num-width'
        },
        {
          key: 'creation_date',
          label: 'Creation Date',
          class: 'text-center'
        },
        // 1.1 <Anuj>
        {
          key: 'last_action_date',
          label: 'Last Action Date',
          class: 'text-center'
        },
        {
          key: 'status_code',
          label: 'Status Code',
          class: 'text-center'
        },
        {
          key: 'status_message',
          label: 'Status Message',
          class: 'text-center'
        },
        {
          key: 'view_details',
          label: 'View Details',
          class: 'text-center'
        }
      ];
      this.getPendingGrnSyncData();
    } else if (this.cardName === 'pendingRecDoc') {
      this.pendingSyncFields = [
        {
          key: 'vendor_name',
          label: 'Vendor Name',
          class: 'text-center'
        },
        {
          key: 'inv_num',
          label: 'Invoice Number',
          class: 'text-center inv-num-width'
        },
        {
          key: 'po_num',
          label: 'PO Number',
          class: 'text-center po-num-width'
        },
        {
          key: 'user_email',
          label: 'User Email',
          class: 'text-center email-width'
        },
        {
          key: 'receipt_number',
          label: 'Receipt Number',
          class: 'text-center po-num-width'
        },
        {
          key: 'grn_attach_flag',
          label: 'GRN Attached',
          class: 'text-center po-num-width'
        },
        {
          key: 'approval_status',
          label: 'Approval Status',
          class: 'text-center po-num-width'
        },
        {
          key: 'creation_date',
          label: 'Creation Date',
          class: 'text-center'
        },
        // 1.1 <Anuj>
        {
          key: 'last_action_date',
          label: 'Last Action Date',
          class: 'text-center'
        },
        {
          key: 'status_code',
          label: 'Status Code',
          class: 'text-center'
        },
        {
          key: 'status_message',
          label: 'Status Message',
          class: 'text-center'
        },
        {
          key: 'view_details',
          label: 'View Details',
          class: 'text-center'
        }
      ];
      this.getPendingRecDocData();
    } else {
      this.pendingSyncData = [];
      this.pendingSyncFields = [];
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        // 1.0 <Anuj> use for download data in excel format
        if (actionName === 'download') {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.downloadpayload };
          downloadpayload._limit = this.totalRows1;
          if (this.cardName === 'pendingInvSync') {
            this.downloadExcel.downloadData(
              downloadpayload,
              'vendorDashboard/getPendingInvSyncData',
              'invoices-sync-to-oracle',
              () => (this.loader = false)
            );
          } else if (this.cardName === 'pendingGrnSync') {
            this.downloadExcel.downloadData(
              downloadpayload,
              'vendorDashboard/getPendingGrnSyncData',
              'grn-sync-to-oracle',
              () => (this.loader = false)
            );
          } else if (this.cardName === 'pendingRecDoc') {
            this.downloadExcel.downloadData(
              downloadpayload,
              'vendorDashboard/getPendingGrnSyncData',
              'pending-receipt-document',
              () => (this.loader = false)
            );
          }
        }
      }
    });
    this.getMenuId();
  },
  methods: {
    // 1.0 <Anuj> To get pending Invoice sync Data
    getPendingInvSyncData() {
      const payload = {
        _page: this.currentPage1 - 1,
        _limit: this.perPage1,
        order_by: this.orderBy,
        order_name: this.orderName
      };
      this.downloadpayload = payload;
      this.loader = true;
      this.$store
        .dispatch('vendorDashboard/getPendingInvSyncData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.pendingSyncData = result;
            this.totalRows1 = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // 1.0 <Anuj> To get pending GRN sync Data
    getPendingGrnSyncData() {
      const payload = {
        _page: this.currentPage1 - 1,
        _limit: this.perPage1,
        order_by: this.orderBy,
        order_name: this.orderName
      };
      this.downloadpayload = payload;
      this.loader = true;
      this.$store
        .dispatch('vendorDashboard/getPendingGrnSyncData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.pendingSyncData = result;
            this.totalRows1 = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // 1.0 <Anuj> To get pending Receipt Document Data
    getPendingRecDocData() {
      const payload = {
        _page: this.currentPage1 - 1,
        _limit: this.perPage1,
        order_by: this.orderBy,
        order_name: this.orderName
      };
      this.downloadpayload = payload;
      this.loader = true;
      this.$store
        .dispatch('vendorDashboard/getPendingRecDocData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.pendingSyncData = result;
            this.totalRows1 = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // 1.0 <Anuj> use for Show Hide Invoice Approve Details Modal
    showHideInvAppDtlsModal(flag, item) {
      this.showInvAppDtlsModal = flag;
      this.invoiceRowData = item;
    },
    // 1.0 <Anuj> use for get menu id
    getMenuId() {
      const payload = {
        event_name: 'invoiceApproval'
      };
      this.$store
        .dispatch('intWorkflow/getDynamicMenuId', payload)
        .then(response => {
          if (response.status === 200) {
            const result = response.data.data;
            if (result) {
              this.wfMenuId = result.menu_id;
              this.getEventId();
            }
          }
        });
    },
    // 1.0 <Anuj> use for get event id
    getEventId() {
      this.$store
        .dispatch('intWorkflow/getEventId', this.wfMenuId)
        .then(response => {
          if (response.status === 200) {
            this.eventId = response.data.data;
          }
        });
    },
    // 1.0 <Anuj> use for sorting data on basis of column asc and des
    sortFunc(item) {
      if (item === 'Creation Date Low to High') {
        this.sortFlag = {
          creationDate: true,
          lastActionDate: false,
          subDate: false,
          vendorName: false,
          userEmail: false
        };
        this.arrowDate = true;
        this.orderBy = 'ASC';
        this.orderName = 'creation_date';
      } else if (item === 'Creation Date High to Low') {
        this.sortFlag = {
          creationDate: true,
          lastActionDate: false,
          subDate: false,
          vendorName: false,
          userEmail: false
        };
        this.arrowDate = false;
        this.orderBy = 'DESC';
        this.orderName = 'creation_date';
        // } else if (item === 'Last Action Date Low to High') {
        //   //1.1 <Anuj>
        //   this.sortFlag = {
        //     creationDate: false,
        //     lastActionDate: true,
        //     subDate: false,
        //     vendorName: false,
        //     userEmail: false
        //   };
        //   this.arrowLastActionDate = true;
        //   this.orderBy = 'ASC';
        //   this.orderName = 'last_action_date';
        // } else if (item === 'Last Action Date High to Low') {
        //   //1.1 <Anuj>
        //   this.sortFlag = {
        //     creationDate: false,
        //     lastActionDate: true,
        //     subDate: false,
        //     vendorName: false,
        //     userEmail: false
        //   };
        //   this.arrowLastActionDate = false;
        //   this.orderBy = 'DESC';
        //   this.orderName = 'last_action_date';
      } else if (item === 'Submission Date Low to High') {
        this.sortFlag = {
          creationDate: false,
          lastActionDate: false,
          subDate: true,
          vendorName: false,
          userEmail: false
        };
        this.arrowSubDate = true;
        this.orderBy = 'ASC';
        this.orderName = 'submission_date';
      } else if (item === 'Submission Date High to Low') {
        this.sortFlag = {
          creationDate: false,
          lastActionDate: false,
          subDate: true,
          vendorName: false,
          userEmail: false
        };
        this.arrowSubDate = false;
        this.orderBy = 'DESC';
        this.orderName = 'submission_date';
      } else if (item === 'Vendor Name Low to High') {
        this.sortFlag = {
          creationDate: false,
          lastActionDate: false,
          subDate: false,
          vendorName: true,
          userEmail: false
        };
        this.arrowVenName = true;
        this.orderBy = 'ASC';
        this.orderName = 'vendor_name';
      } else if (item === 'Vendor Name High to Low') {
        this.sortFlag = {
          creationDate: false,
          lastActionDate: false,
          subDate: false,
          vendorName: true,
          userEmail: false
        };
        this.arrowVenName = false;
        this.orderBy = 'DESC';
        this.orderName = 'vendor_name';
      } else if (item === 'User Email Low to High') {
        this.sortFlag = {
          creationDate: false,
          lastActionDate: false,
          subDate: false,
          vendorName: false,
          userEmail: true
        };
        this.arrowUserEmail = true;
        this.orderBy = 'ASC';
        this.orderName = 'user_email';
      } else if (item === 'User Email High to Low') {
        this.sortFlag = {
          creationDate: false,
          lastActionDate: false,
          subDate: false,
          vendorName: false,
          userEmail: true
        };
        this.arrowUserEmail = false;
        this.orderBy = 'DESC';
        this.orderName = 'user_email';
      }
      if (this.cardName === 'pendingInvSync') {
        this.getPendingInvSyncData();
      } else if (this.cardName === 'pendingGrnSync') {
        this.getPendingGrnSyncData();
      } else if (this.cardName === 'pendingRecDoc') {
        this.getPendingRecDocData();
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
